import React from 'react';
import { Box, Typography } from '@mui/material';
import TodayIcon from '@mui/icons-material/Today';
import DateRangeIcon from '@mui/icons-material/DateRange';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

const CARDS = [
  {
    id: 'today',
    title: "Today's Earnings",
    key: 'today',
    icon: <TodayIcon />,
    gradient: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
    iconColor: '#d97706',
    iconBg:    'rgba(217,119,6,0.12)',
    border:    '#fef3c7',
  },
  {
    id: 'week',
    title: 'This Week',
    key: 'week',
    icon: <DateRangeIcon />,
    gradient: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
    iconColor: '#1976d2',
    iconBg:    'rgba(25,118,210,0.10)',
    border:    '#e3eeff',
  },
  {
    id: 'month',
    title: 'This Month',
    key: 'month',
    icon: <CalendarMonthIcon />,
    gradient: 'linear-gradient(135deg, #2e7d32 0%, #1b5e20 100%)',
    iconColor: '#16a34a',
    iconBg:    'rgba(22,163,74,0.10)',
    border:    '#dcfce7',
  },
];

export default function AgentCommissionSummary({ summary = {} }) {
  return (
    <Box
      sx={{
        display: 'grid',
        gap: 1.5,
        gridTemplateColumns: {
          xs: 'repeat(1, 1fr)',
          md: 'repeat(1, 1fr)',
          lg: 'repeat(1, 1fr)',
        },
        alignItems: 'stretch',
      }}
    >
      {CARDS.map((c) => (
        <Box
          key={c.id}
          sx={{
            p: 1.25,
            borderRadius: '12px',
            bgcolor: '#fff',
            border: `1.5px solid ${c.border}`,
            boxShadow: '0 2px 10px rgba(15,23,42,0.06)',
            display: 'flex',
            alignItems: 'center',
            gap: { xs: 1, sm: 1.25 },
            width: '100%',
            maxWidth: '100%',
            overflow: 'hidden',
            boxSizing: 'border-box',
            minHeight: { xs: 80, sm: 80, md: 90 },
          }}
        >
          {/* Icon badge */}
          <Box
            sx={{
              width:  { xs: 34, sm: 38, lg: 36 },
              height: { xs: 34, sm: 38, lg: 36 },
              borderRadius: '10px',
              bgcolor: c.iconBg,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            {React.cloneElement(c.icon, {
              sx: {
                fontSize: { xs: 18, sm: 20, lg: 18 },
                color: c.iconColor,
              },
            })}
          </Box>

          {/* Text */}
          <Box sx={{ minWidth: 0, flex: 1 }}>
            <Typography
              sx={{
                fontSize: { xs: '0.65rem', sm: '0.7rem', lg: '0.68rem' },
                fontWeight: 500,
                color: '#64748b',
                lineHeight: 1.2,
                mb: 0.4,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
              }}
            >
              {c.title}
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: '1.1rem', sm: '1.2rem', lg: '1rem' },
                fontWeight: 700,
                lineHeight: 1,
                color: '#0f172a',
              }}
            >
              {summary[c.key] ?? '₹0'}
            </Typography>
          </Box>
        </Box>
      ))}
    </Box>
  );
}
